<template>
  <div id="historial-pagos-container">
    <div class="card-item">
      <TransactionsHistory
        id="transactions-history"
        :client-id="clientId"
        :current-user-is-client="!!clientId"
        :payment-providers="paymentProviders" />
    </div>
  </div>
</template>
<script>
import TransactionsHistory from '@/ui/components/internal/pay-here/TransactionsHistory.vue';
import { getTransactionsProviders } from '@/application/services/api-clients/transactions';

export default {
  name: 'TransactionsHistoryContainer',
  components: { TransactionsHistory },
  data() {
    return {
      clientId: this.$store.state.currentUser.user.clientId,
      paymentProviders: []
    };
  },
  async beforeCreate() {
    try {
      this.paymentProviders = await getTransactionsProviders();
    } catch (_error) {
      this.message = 'Ocurrió un error al obtener la información de los proveedores';
    }
  }
};
</script>
<style scoped>
#historial-pagos-container {
  margin-top: 3rem;
  overflow: visible !important;
}
</style>
